import React from 'react';
import _ from 'lodash';

import Dropzone from 'components/Dropzone';

import {
  UploadFilePlaceholder,
  WrongFormat,
  UploadedFileOption
} from 'components/SingleFileUpload';

import './styles.css';

interface MultipleFileUploadProps {
  files: Array<any>;
  onFileDrop: (files) => void;
  onFileRemove?: (file) => void;
  wrongFormat?: boolean;
  placeholderIcon: any;
  placeholderText: string;
  acceptedFileTypes: string;
  filesLabel: string;
}

const FileDropZone = ({
  defaultComponent,
  onFileDrop,
  wrongFormat,
  acceptedFileTypes
}) => (
  <Dropzone
    onDrop={onFileDrop}
    multiple={false}
    acceptedFileTypes={acceptedFileTypes}
    defaultComponent={
      <React.Fragment>
        {wrongFormat && <WrongFormat />}
        {!wrongFormat && defaultComponent}
      </React.Fragment>
    }
  />
);

const AddAnotherFilePlaceholder = () => (
  <div className="AddAnotherFilePlaceholder colab-centered colab-bold">
    Add another
  </div>
);

class MultipleFileUpload extends React.Component<MultipleFileUploadProps> {
  render() {
    const {
      files = [],
      onFileDrop,
      wrongFormat,
      onFileRemove,
      placeholderText,
      placeholderIcon,
      acceptedFileTypes,
      filesLabel
    } = this.props;

    return (
      <div className="MultipleFileUpload FileUpload">
        {_.isEmpty(files) && (
          <FileDropZone
            defaultComponent={
              <UploadFilePlaceholder
                placeholderIcon={placeholderIcon}
                placeholderText={placeholderText}
              />
            }
            onFileDrop={onFileDrop}
            wrongFormat={wrongFormat}
            acceptedFileTypes={acceptedFileTypes}
          />
        )}
        {!_.isEmpty(files) && (
          <div className="FileUpload__container">
            <div className="FileUpload__container__header colab-bold">
              {filesLabel}
            </div>
            {files.map(file => (
              <UploadedFileOption
                key={file.preview}
                onFileRemove={onFileRemove}
                file={file}
                fileName={file.name}
                filePreview={file.preview}
              />
            ))}
            <FileDropZone
              defaultComponent={<AddAnotherFilePlaceholder />}
              onFileDrop={onFileDrop}
              wrongFormat={wrongFormat}
              acceptedFileTypes={acceptedFileTypes}
            />
          </div>
        )}
      </div>
    );
  }
}

export default MultipleFileUpload;
